import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class IncorporadoraAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'incorporadoras';
	}
	/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public save(incorporadoraNome?) {
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity + '/save', {incorporadoraNome} , 'post');        
	}
	/**
	 * get incorporadora by nome
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public getByIncorporadoraName(data) {
		// return this._call(this.__entity + '/save', data);
		let hasName = {};
		if(data){
			hasName = {Nome_like:data}
		}
		return this._call(this.__entity, hasName , 'get');        
	}
}


// WEBPACK FOOTER //
// ./src/api/incorporadora.api.ts